(function Captcha($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.Captcha.init();
	});
}(jQuery, window.Adzuki || {}));
